export function Office365LitePermissionSelection(props) {
    function handleChange(groupName, value) {
        props.setGroupMappings(prev => ({
            ...prev,
            [props.organization.id]: {
                ...prev[props.organization.id],
                [groupName]: value,
            }
        }))
    }

    return <tr>
        <th scope="row">
            {props.organization.title}{props.organization.type === "district" ? " (and all schools" : ""}
        </th>
        <td style={{textAlign: "right"}}>
            Department: <input
                className="group"
                type="text"
                value={props.groupMappings[props.organization.id].department}
                onChange={e => handleChange("department", e.target.value)}
            />
            <br/>
            School Blocks Admins: <input
                className="group"
                type="text"
                value={props.groupMappings[props.organization.id].adminGroup}
                onChange={e => handleChange("adminGroup", e.target.value)}
            />
            <br/>
            Staff: <input
                className="group"
                type="text"
                value={props.groupMappings[props.organization.id].staffGroup}
                onChange={e => handleChange("staffGroup", e.target.value)}
            />
            <br/>
            {props.organization.type === "school" && <>
                Teachers: <input
                    className="group"
                    type="text"
                    value={props.groupMappings[props.organization.id].teacherGroup}
                    onChange={e => handleChange("teacherGroup", e.target.value)}
                />
                <br/>
                Students: <input
                    className="group"
                    type="text"
                    value={props.groupMappings[props.organization.id].studentGroup}
                    onChange={e => handleChange("studentGroup", e.target.value)}
                />
            </>}
        </td>
    </tr>
}